import { render, staticRenderFns } from "./LayoutTabs.vue?vue&type=template&id=116f0828"
import script from "./LayoutTabs.vue?vue&type=script&lang=js"
export * from "./LayoutTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports